// apps/client/src/ui/hud/Banner.tsx — the "Reconnecting…" pill while the socket backs off and resyncs (spec §14), below the HUD row on
// the right, above the toasts (tokens.css .hud-banner).
// The update prompt is not here: it is the `update` phase screen (revision 9 item 1).
import { useGame } from '../../state/store';
import { useT } from '../i18n';

const CSS = '@keyframes wt-banner-pulse { 0%, 100% { opacity: 1 } 50% { opacity: .62 } }';
let styled = false;
function injectStyle(): void {
  if (styled || typeof document === 'undefined') return;
  styled = true;
  const el = document.createElement('style');
  el.dataset.owner = 'hud';
  el.textContent = CSS;
  document.head.appendChild(el);
}
export function Banner() {
  const t = useT();
  const banner = useGame((s) => s.banner);
  if (banner !== 'reconnecting') return null;
  injectStyle();
  return (
    <div role="status" data-hud className="hud-banner" style={{ background: 'var(--cream-50)', color: 'var(--wood-800)', fontWeight: 900, fontSize: 17, borderRadius: 'var(--r-pill)', padding: '.5em 1.1em .55em',
      boxShadow: 'var(--sh-hud)', animation: 'wt-banner-pulse 1.6s var(--ease-out) infinite' }}>
      {t('hud.reconnecting')}
    </div>
  );
}
